import $ from 'jquery';

// vue and vue components
import Vue from 'vue';
import Vuex from 'vuex';
import VeeValidate from 'vee-validate';
import Multiselect from 'vue-multiselect';
import VueRouter from 'vue-router';
import VueI18n from 'vue-i18n';
import VueLoading from 'vue-loading-overlay';
import Notify from 'vue-notifyjs';
import VueFormGenerator from 'vue-form-generator/dist/vfg';
import VueGoodTablePlugin from 'vue-good-table';

// External libraries
import axios from 'axios';
import moment from 'moment';
import 'moment/locale/fr';
import _ from 'lodash';

// LightBootstrap plugin
import LightBootstrap from './light-bootstrap-main';
import 'bootstrap/dist/js/bootstrap.bundle.min';
import fieldEnyoSelect from '@/components/UIComponents/FieldEnyoSelect.vue';

// router setup and local elements setup
import config from './config';
import store from './stores';
import routes from './routes/routes';
import localeFr from './config/locales/fr.json';
import * as filters from './filters/filters';
import App from './App.vue';

// plugin setup
Vue.use(VeeValidate, {
  inject: false
});
Vue.use(Vuex);
Vue.use(VueRouter);
Vue.use(LightBootstrap);
Vue.use(Notify, {
  type: 'primary',
  timeout: 1000
});
Vue.use(VueLoading);
Vue.use(VueI18n);
Vue.use(VueFormGenerator);
Vue.use(VueGoodTablePlugin);
Vue.component('fieldEnyoSelect', fieldEnyoSelect);

Object.keys(filters).forEach((key) => {
  Vue.filter(key, filters[key]);
});

// Vue.use(Notifications)

Vue.component('multiselect', Multiselect);
Vue.component('vue-form-generator', VueFormGenerator);

// Vue.component('v-select', vSelect);
//
// Vue.use(Notify, {type: 'primary', timeout: 2000})

// global variables
window.App = {
  locale: config.defaultLocale || 'fr'
};
window.$ = $;
window.jQuery = $;
window._ = _;
window.moment = moment;

Vue.config.productionTip = false;
axios.defaults.withCredentials = true;

Vue.prototype.$http = axios.create({
  baseURL: config.apiUrl,
  headers: {
    Accept: 'application/json',
    'Content-Type': 'application/json',
    Authorization: `Bearer ${localStorage.getItem(`${config.appName}_token`)}`
  }
});

/* eslint-disable no-new */
let v = null;
Vue.prototype.$http.interceptors.response.use((response) => response, (error) => {
  if (error && error.response && error.response.status === 401) {
    /*
      swal({
          title: "Session Expired",
          text: "Your session has expired. Would you like to be redirected to the login page?",
          type: "warning",
          showCancelButton: true,
          confirmButtonColor: "#DD6B55",
          confirmButtonText: "Yes",
          closeOnConfirm: false
      }, function(){
          window.location = '/login';
      });
      */

    if (
      error.response
      && error.response.config
      && error.response.config.url
      && (error.response.config.url.indexOf('/login') === -1
        || error.response.config.url.indexOf('/register') === -1)) {
      store.dispatch('logout');
      v.$router.push('/login');
      // v.$notify("Your session has expired");
    }
  }
  return Promise.reject(error);
});

// configure router
const router = new VueRouter({
  base: '/',
  mode: 'history',
  routes, // short for routes: routes
  linkActiveClass: 'nav-item active'
});

router.beforeEach((to, from, next) => {
  document.title = `${config.defaultTitle} - ${to.meta.title || to.name}`;
  next();
});

const messages = {
  fr: localeFr
};

console.warn({
  locale: window.App.locale, // set locale
  messages // set locale messages
});
const i18n = new VueI18n({
  locale: window.App.locale, // set locale
  messages // set locale messages
});

function initVue() {
  v = new Vue({
    el: '#app',
    render: (h) => h(App),
    router,
    store,
    i18n
  });
  window.App.vue = v;

  if (localStorage.getItem(`${config.appName}_token`)) {
    v.$store
      .dispatch('refreshUser')
      .then((res) => {
        if (v.$route.name === 'Login') {
          //  v.$router.push('/')
        }
      })
      .catch((err) => {
        console.error(err);
      });
  }
}

store
  .dispatch('getDynamicPages')
  .then(initVue)
  .catch(initVue);
